import validation from '../../../../../modules/Gull/Framework/validation.js';
import bootstrapNotify from '../../../../../modules/Gull/Framework/bootstrapNotify.js';

const aanvraagVerwerken = {

	init() {

		$('#aanvraagGoedkeuren').attr('href-backup', $('#aanvraagGoedkeuren').attr('href'));

		$('.validate-row').click(function() {
			aanvraagVerwerken.validateRow($(this).closest('tr'), 'success', 1, 0, 0);
		});

		$('.validate-row-ccs').click(function() {
			aanvraagVerwerken.validateRow($(this).closest('tr'), 'success', 0, 0, 1);
		});

		// Functie om ccs relatie nummer veld op 0 te zetten
		$('.validate-row-ccs-new').click(function() {
			$($(this).closest('tr')).find('input[name=CCS_relnr]').val('0');
			aanvraagVerwerken.validateRow($(this).closest('tr'), 'success', 0, 1, 1);
		});

		$('.delete-row').click(function() {
			aanvraagVerwerken.validateRow($(this).closest('tr'), 'danger', 1, 0, 0);
		});

		$('.opmerking-row-submit').click(function() {
			var status = $(this).closest('tr').attr('class');

			aanvraagVerwerken.validateRow($(this).closest('tr'), status, 1, 1, 0);

			$(this).closest('tr').find('div.opmerkingen').hide(200);
		});

		$('.opmerking-row').click(function() {
			$(this).closest('tr').find('div.opmerkingen').show(400);
		});

		$('button.terugzetten').click(function(e) {
			e.preventDefault();
			window.location.href = '1/terugzetten/concept';
		});

		$('button.afwijzen').click(function(e) {
			e.preventDefault();
			window.location.href = '1/afwijzen/concept';
		});

		$('button.claim').click(function(e) {
			e.preventDefault();
			window.location.href = '1/claim';
		});

		$('.tab-pane table tbody').each(function() {
			aanvraagVerwerken.validateTab($(this).find('tr').first());
		});

		$(function() {
			$('#fileUploadButton').click(function(e) {
				$('#fileUploadField').click();
				e.preventDefault();
			});
		});

		$('#fileUploadField').on('change', function() {
			$('#uploadFileForm').submit();
		});

		$('#opmerkingenOpslaan').click(function() {
			$('#opmerkingen').attr('target', '');
			$('#formAction').val('');
			$('#opmerkingen').submit();
		});

		$('#offerteUitbrengen').click(function() {
			$('#opmerkingen').attr('target', '');
			$('#formAction').val('offerteUitbrengen');
			$('#opmerkingen').submit();
		});

		$('#offerteInzien').click(function() {
			$('#formAction').val('offerteInzien');
			$('#opmerkingen').attr('target', '_blank');
			$('#opmerkingen').submit();
		});

		$('#garantieVerklaringInzien').click(function() {
			aanvraagVerwerken.saveGarantieverklaring();
			setTimeout(function() {
				$('#formAction').val('garantieVerklaringInzien');
				$('#formProductID').val($(this).data('product-id'));
				$('#formMaatschappij').val($(this).data('maatschappij'));
				$('#opmerkingen').attr('target', '_blank');
				$('#opmerkingen').submit();
			}, 1000);
		});

		$('#opmerkingenOpslaan').click(function() {
			$('#formAction').val('');
			$('#opmerkingen').attr('target', '');
			$('#opmerkingen').submit();
		});

		$('.submit-modal').click(function() {
			var product = $(this).attr('product');
			var Mij = $(this).attr('Mij');
			var dekking = $(this).attr('dekking');

			var error = new Array();
			$('form#modalForm' + product + ' input[data-validate],select[data-validate],textarea[data-validate]').each(function() {
				if ($(this).prop('disabled') == false) {
					if (validation.checkInput(this) === 'error') {
						error.push($(this).attr('name'));
					}
				}
			});

			if (error.length > 0) {
				bootstrapNotify('danger', '', 'Er zitten fouten in de velden: <br>' + error.join(',<br>') + '!');
			} else {
				var actionArray = [document.URL, 'SaveModalAanpassing', product, Mij, dekking, '', ''];

				var post_data = $('form#modalForm' + product).serialize();

				$.post(actionArray.join('/'), post_data, function(data) {
					if (data == false) {
						bootstrapNotify('danger', '', 'Er is iets fout gegaan met het opslaan van de gegevens!');
					} else {
						$('.modal').modal('hide');
						$('#showAanpassingTeken' + product).removeClass('d-none');
						if ($('form#modalForm' + product).find('input[type=checkbox]').is(':checked')) {
							$('#showAanpassingTeken' + product).removeClass('d-none');
						} else {
							$('#showAanpassingTeken' + product).addClass('d-none');
						}
					}
				});
			}
		});

		$('.submit-garantieverklaring-modal').click(function() {
			aanvraagVerwerken.saveGarantieverklaring();
		});

		$('.product-modal .input-group-text').parent().click(function() {
			if ($(this).find('input').is(':checked')) {
				$(this).parent().find('.form-control:last-of-type(),.form-select:last-of-type()').removeAttr('disabled').focus()
					.closest('div.form-group').parent().closest('div.form-group').removeClass('has-error').find('.mutatie-reden').removeAttr('disabled').closest('div.form-group').removeClass('has-error');
			} else {
				$(this).parent().find('.form-control,.form-select').attr('disabled', 'true').closest('div.form-group').removeClass('has-error').parent().closest('div.form-group').find('.mutatie-reden').attr('disabled', 'true').closest('div.form-group').removeClass('has-error');
			}

			var disabled = true;
			if ($('#content-wrapper form input[type=checkbox]').is(':checked')) {
				disabled = false;
			}
			$(this).closest('form').find('button').attr('disabled', disabled);
		});

		$('.handmatig-verwerken').change(function() {
			if ($(this).is(':checked')) {
				$(this).closest('div.form-group').find('textarea').removeAttr('disabled').closest('div.form-group').css('display', 'none').removeClass('d-none').slideDown(300);
			} else {
				$(this).closest('div.form-group').find('textarea').closest('div.form-group').slideUp(300, function() {
					$(this).addClass('d-none').find('textarea').attr('disabled', 'true');
				});
			}
		});

		$('.modal.product-modal').on('shown.bs.modal', function() {
			// Check of de waarde in veld b gelijk is aan de waarde in veld a
			$(this).find('input[type=checkbox]').each(function() {
				if ($(this).is(':checked')) {
					if ($(this).hasClass('handmatig-verwerken')) {
						$(this).trigger('change');
					} else {
						$(this).parent().trigger('click');
					}
				}
			});
		});

		$('#aanvraagvalidatie_checklist_aanvraag .checklist-vraag td:first-child').click(function(e) {
			e.preventDefault();
			var answer = $(this).parent().find('.answer-value').val();
			if (answer == 'ja') {
				$(this).parent().find('input[type=checkbox].nee').click();
			} else if (answer == 'nee') {
				$(this).parent().find('input[type=checkbox].nvt').click();
			} else {
				$(this).parent().find('input[type=checkbox].ja').click();
			}
		});

		$('#aanvraagvalidatie_checklist_aanvraag .checklist-vraag input[type=checkbox]').change(function() {
			var checked = $(this).is(':checked');
			$(this).parent().parent().find('input[type=checkbox]').prop('checked', false);
			if (checked) {
				$(this).prop('checked', true);
				var answer = $(this).prop('name').split('_').pop();
				$(this).parent().parent().find('.answer-value').val(answer);
				$(this).parent().parent().find('.answer-feedback').removeAttr('disabled');
			} else {
				$(this).parent().parent().find('.answer-value').val('');
				$(this).parent().parent().find('.answer-feedback').attr('disabled', true);
			}
		});

		$('#aanvraagvalidatie_checklist_aanvraag .checklist-vraag input').change(function() {
			var key = $(this).parent().parent().data('key');
			var vraagkey = $(this).parent().parent().data('vraag-key');
			var value = $(this).parent().parent().find('.answer-value').val();
			var actionArray = [document.URL, 'SaveChecklistRow', key, vraagkey, value, ''];
			var this_row = $(this).parent().parent();
			$.post(actionArray.join('/'), {
				toelichting: $(this).parent().parent().find('.answer-feedback').val()
			}, function(data) {
				var status;
				if (data == false) {
					status = 'warning';
					bootstrapNotify('danger', '', 'Er is iets fout gegaan met het opslaan van de gegevens!', 5000);
				} else {
					if (value == '') {
						status = 'warning table-warning';
					} else {
						status = 'success table-success';
					}
				}

				// $(this_row).removeClass('warning').removeClass('success').removeClass('danger').addClass(status);
				$(this_row).removeClass('warning').removeClass('success').removeClass('danger').removeClass('table-warning').removeClass('table-success').removeClass('table-danger').addClass(status);

				aanvraagVerwerken.validateTab(this_row);
			});
		});

		$('.product-modal').each(function() {
			$(this).find('.input-group-text input[type=checkbox]:checked').closest('.input-group ').find('input,select').removeAttr('disabled').closest('.input-group ').find('input.mutatie-reden').removeAttr('disabled');
		});

		$(document).ready(function() {
			aanvraagVerwerken.toggleGarantieverklaring();
		});

		$('.garantieverklaring').change(aanvraagVerwerken.toggleGarantieverklaring);

		// Activate first tab
		var firstTabEl = document.querySelector('.premie-validatie-tabs li:first-child a');
		if (firstTabEl !== null) {
			var firstTab = new bootstrap.Tab(firstTabEl);
			firstTab.show();
		}



	},

	validateComplete: function() {
		// Valideer alle premieverzoeken van alle maatschappijen
		if ($('.tab-pane table tbody').children().hasClass('warning')) {
			// Maak de offerte knoppen selecteerbaar (enabled)
			$('ul.nav-tabs.premie-validatie-tabs button:not(.no-disable)').attr('disabled', true);
			$('ul.nav-tabs.premie-validatie-tabs a.btn:not(.no-disable)').attr('disabled', true);
			$('ul.nav-tabs.premie-validatie-tabs a.btn:not(.no-disable)').each(function() {
				$(this).attr('href', '#');
			});
		} else {
			// Maak de offerte knoppen NIET selecteerbaar (disabled)
			$('ul.nav-tabs.premie-validatie-tabs button').attr('disabled', false);
			$('ul.nav-tabs.premie-validatie-tabs a').attr('disabled', false);
			$('ul.nav-tabs.premie-validatie-tabs a.btn:not(.no-disable)').each(function() {
				$(this).attr('href', $(this).attr('href-backup'));
			});
		}
	},

	validateTab: function(this_row) {
		var tab = $(this_row).closest('div.tab-pane').attr('tab');
		// VALIDEER DE HUIDIGE TABEL OP OPENSTAANDE PREMIEVERZOEKEN
		if ($(this_row).closest('.tab-pane[tab=' + tab + '] table tbody').children().hasClass('warning')) {
			// MAAK DE MAATSCHAPPIJ TAB GRIJS
			$('ul.nav-tabs li[tab=' + tab + '] a.maatschapij-tab').removeClass('bg-warning').removeClass('bg-success').addClass('bg-warning bg-opacity-25');
		} else {
			// MAAK DE MAATSCHAPPIJ TAB GROEN
			$('ul.nav-tabs li[tab=' + tab + '] a.maatschapij-tab').removeClass('bg-warning').removeClass('bg-success').addClass('bg-success bg-opacity-25');
		}
		aanvraagVerwerken.validateComplete();
	},

	SaveRow: function(this_row, status) {
		var product = $(this_row).attr('product');
		var Mij = $(this_row).attr('Mij');
		var dekking = $(this_row).attr('dekking');

		var actionArray = [document.URL, 'SaveRow', product, Mij, dekking, status, ''];
		$.post(actionArray.join('/'), {
			opmerking: $(this_row).find('textarea[name=opmerking]').val()
		}, function(data) {
			if (data == false) {
				aanvraagVerwerken.validateRow(this_row, 'warning', 0, 0);
				bootstrapNotify('danger', '', 'Er is iets fout gegaan met het opslaan van de gegevens!');
			}
		});
	},

	SaveRowCCS: function(this_row) {
		var field = $(this_row).find('input').attr('name');
		var value = $(this_row).find('input').val();

		var actionArray = [document.URL, 'SaveRowCCS', field, value, ''];

		$.getJSON(actionArray.join('/'), function(data) {
			if (data == false) {
				aanvraagVerwerken.validateRow(this_row, 'warning', 0, 0, 0);
				bootstrapNotify('danger', '', 'Er is iets fout gegaan met het opslaan van de gegevens!');
			}
		});
	},

	validateRow: function(this_row, status, save, overwrite, saveccs) {
		if ($(this_row).hasClass(status) && overwrite == 0) {
			// kleur de rij(this_row) oranje
			$(this_row).removeClass(status).addClass('warning');
			status = 'warning';
		}

		$(this_row).removeClass('warning').removeClass('success').removeClass('danger').removeClass('table-warning').removeClass('table-success').removeClass('table-danger').addClass('table-' + status);

		if (save == 1) {
			aanvraagVerwerken.SaveRow(this_row, status);
		}
		if (saveccs == 1) {
			aanvraagVerwerken.SaveRowCCS(this_row, status);
		}
		aanvraagVerwerken.validateTab(this_row);
	},

	saveGarantieverklaring: function() {
		var product = $('.submit-garantieverklaring-modal').attr('product');
		var Mij = $('.submit-garantieverklaring-modal').attr('Mij');
		var dekking = $('.submit-garantieverklaring-modal').attr('dekking');
		var actionArray = [document.URL, 'SaveGarantieVerklaringAanpassing', product, Mij, dekking, '', ''];
		var post_data = $('form#modalFormGarantieVerklaring' + product).serialize();
		$('#modal_garantieverklaring_' + product + ' .loading-spinner').removeClass('d-none');
		$.post(actionArray.join('/'), post_data, function(data) {
			if (data == false) {
				bootstrapNotify('danger', '', 'Er is iets fout gegaan met het opslaan van de gegevens!');
			}
			$('#modal_garantieverklaring_' + product + ' .loading-spinner').addClass('d-none');
		});
	},

	// Functie om garantieverklaring te tonen en verbergen
	toggleGarantieverklaring: function() {
		var e = $('.garantieverklaring');
		var b = $('.ingangsdatumEigenrisicodragerschapBestaandeWerkgever');
		var o = $('.vervalDatumGarantieVorigeBank');
		var i = $('.ingangsDatumGarantieNieuweBank');
		var h = $('.naamHuidigeVerzekeraarOfBank');
		b.closest('.form-group').addClass('d-none');
		o.closest('.form-group').addClass('d-none');
		i.closest('.form-group').addClass('d-none');
		h.closest('.form-group').addClass('d-none');
		validation.removeRequired(b);
		validation.removeRequired(o);
		validation.removeRequired(i);
		validation.removeRequired(h);
		o.val('');
		i.val('');
		b.val('');
		if (e.length) {
			if (e.val() == 'bestaande-werkgever-die-eigenrisicodrager-wordt') {
				b.closest('.form-group').removeClass('d-none');
				validation.addRequired(b);
			} else if (e.val() == 'eigenrisicodrager-die-overstapt-naar-bank-of-verzekeraar') {
				o.closest('.form-group').removeClass('d-none');
				validation.addRequired(o);
				i.closest('.form-group').removeClass('d-none');
				validation.addRequired(i);
				h.closest('.form-group').removeClass('d-none');
				validation.addRequired(h);
			}
		}
	}

};

export default aanvraagVerwerken;
